<div class="mobile-header">
    <h5>Dashboard</h5>
</div>

<section>
    <div class="container-fluid">
        <div class="row widget-drop-list"
             cdkDropList
             [cdkDropListData]="widgets"
             (cdkDropListDropped)="onWidgetDrop($event)">
            <ng-container *ngFor="let widget of widgets">
                <div *ngIf="isWidgetVisible(widget)"
                     cdkDrag
                     [class]="widget.colClass + ' widget-drag-item' + (widget.hiddenClass ? ' ' + widget.hiddenClass : '') + (widget.id.startsWith('total-') || widget.id === 'orders-by-location' ? ' widget-stat' : '')">
                    <div class="widget-drag-placeholder" *cdkDragPlaceholder></div>
                    <div class="widget-drag-handle" cdkDragHandle>
                        <mat-icon>drag_indicator</mat-icon>
                    </div>
                    <ng-container [ngSwitch]="widget.id">

                        <!-- Pricing Update Generator -->
                        <app-fbo-prices-update-generator *ngSwitchCase="'pricing-update'"
                                                         [isCsr]="isCsr"
                                                         [isMember]="isMember"></app-fbo-prices-update-generator>

                        <!-- Lost Opportunities -->
                        <ni-card *ngSwitchCase="'lost-opportunities'"
                                 [collapsible]="false"
                                 [opened]="true"
                                 bgColor="dead"
                                 headerBgColor="dead"
                                 outline="true"
                                 theme="small"
                                 title="Lost Opportunities">
                            <div class="app-fbos-missed-quotes-grid">
                                <app-fbos-missed-quotes-grid #missedQuotes></app-fbos-missed-quotes-grid>
                            </div>
                        </ni-card>

                        <!-- New FuelerLinx Operators -->
                        <ni-card *ngSwitchCase="'new-fuelerlinx-operators'"
                                 [collapsible]="false"
                                 [opened]="true"
                                 bgColor="dead"
                                 headerBgColor="dead"
                                 outline="true"
                                 theme="small"
                                 title="New FuelerLinx Operators">
                            <div class="app-fbos-missed-quotes-grid">
                                <app-recently-added-fuelerlinx-customers #recentlyAddedCustomers></app-recently-added-fuelerlinx-customers>
                            </div>
                        </ni-card>

                        <!-- Flight Watch -->
                        <ni-card *ngSwitchCase="'flight-watch'"
                                 [collapsible]="false"
                                 [opened]="true"
                                 bgColor="dead"
                                 headerBgColor="dead"
                                 outline="true"
                                 theme="small"
                                 title="Flight Watch - Live Flight Tracking">
                            <div class="map-container">
                                <div class="map-clickable-top-layer"
                                     (click)="gotoFlightWatch()">
                                </div>
                                <ng-container *ngIf="!isDefaultMap">
                                    <app-twelve-hundred-aero-map [fboId]="fboid"
                                                                 [icao]="selectedICAO"></app-twelve-hundred-aero-map>
                                </ng-container>
                                <ng-container *ngIf="isDefaultMap">
                                    <app-flight-watch-map-wrapper [center]="center"
                                                                  [data]="flightWatchData"
                                                                  [isStable]="isStable"
                                                                  [icao]="selectedICAO"
                                                                  [showFilters]="false"></app-flight-watch-map-wrapper>
                                </ng-container>
                            </div>
                        </ni-card>

                        <!-- Lost To Competition -->
                        <ni-card *ngSwitchCase="'lost-to-competition'"
                                 [collapsible]="false"
                                 [opened]="true"
                                 bgColor="dead"
                                 class="prices-board-item prices-board-second-column price-checker"
                                 headerBgColor="dead"
                                 outline="true"
                                 theme="small"
                                 title="Lost To Competition">
                            <app-fbos-missed-orders-grid #missedOrders></app-fbos-missed-orders-grid>
                        </ni-card>

                        <!-- Statistics -->
                        <app-statistics-total-customers *ngSwitchCase="'total-customers'"
                                                        #statisticsTotalCustomers
                                                        [endDate]="filterEndDate"
                                                        [startDate]="filterStartDate"></app-statistics-total-customers>
                        <app-statistics-total-aircraft *ngSwitchCase="'total-aircraft'"
                                                       #statisticsTotalAircraft
                                                       [endDate]="filterEndDate"
                                                       [startDate]="filterStartDate"></app-statistics-total-aircraft>
                        <app-statistics-total-orders *ngSwitchCase="'total-orders'"
                                                     #statisticsTotalOrders
                                                     [endDate]="filterEndDate"
                                                     [startDate]="pastThirtyDaysStartDate"></app-statistics-total-orders>
                        <app-statistics-orders-by-location *ngSwitchCase="'orders-by-location'"
                                                           #statisticsOrdersByLocation
                                                           [endDate]="filterEndDate"
                                                           [startDate]="pastThirtyDaysStartDate"></app-statistics-orders-by-location>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</section>
